<div class="cast-container">
  <div *ngIf="!active || isAudioOnly" class="backdrop" [responsiveBackgroundImage]="backgroundImage" [class.blurred]="mediaThumbnail">
  </div>

  <div *ngIf="!active || isAudioOnly" class="ready-to-cast">
    <ng-container *ngIf="paywalled">
      <div class="paywall">
        <!--<div class="thumbnail-container">
          <div class="cast-thumbnail" [responsiveBackgroundImage]="mediaThumbnail"></div>
        </div>-->
        <div>
          <div>
              <div style="display: flex">
                <div *ngIf="mediaIsLive" class="is-live">
                  <tyt-live-tag></tyt-live-tag>
                </div>
                <h1>{{mediaShowName}}</h1>
              </div>
              <p>{{mediaTitle}}</p>
          </div>
          <br/>
          <h2>This content is only available to TYT members</h2>

          <ul>
            <li>To become a member, visit <strong>tyt.com/join</strong></li>
            <li><strong>Already a member?</strong> Make sure to log in on the device you are casting from!</li>
            <li>Visit <strong>tyt.com/account</strong> to check your account status.</li>
            <li>If you believe something's wrong, contact <strong>support@tytnetwork.com</strong></li>
          </ul>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!paywalled">
      <ng-container *ngIf="isAudioOnly">

        <div class="paywall">
          <h1>{{mediaShowName}}</h1>
          <p>{{mediaTitle}}</p>
        </div>
      </ng-container>
      <ng-container *ngIf="!isAudioOnly">
        <ng-container *ngIf="loading">
          Loading...
        </ng-container>
        <ng-container *ngIf="!loading">
          <svg class="logo" version="1.1" x="0px" y="0px"
              viewBox="0 0 279.1 198.2" style="enable-background:new 0 0 279.1 198.2;" xml:space="preserve">
              <path d="M265,0h-251C6.3,0,0,6.3,0,14.1v126.2c0,6,3.8,11.3,9.4,13.3L134,197.4c3,1,6.2,1.1,9.2,0.1l126.4-42.6
                c5.7-1.9,9.6-7.3,9.6-13.3V14.1C279.1,6.3,272.8,0,265,0z"/>
              <g>
                <path class="st0" d="M94.6,49.1l-6.5-19.6c-0.4-1.2-1.5-2-2.7-2H24.6c-1.8,0-3.2,1.7-2.8,3.5l4.4,19.6c0.3,1.3,1.5,2.3,2.8,2.3
                  h17.3c1.6,0,2.9,1.3,2.9,2.9v84c0,1.3,0.9,2.5,2.3,2.8l21.1,4.7c1.8,0.4,3.5-1,3.5-2.8V55.8c0-1.6,1.3-2.9,2.9-2.9h12.9
                  C93.8,52.9,95.2,50.9,94.6,49.1z"/>
                <path class="st0" d="M184.5,49.1l6.5-19.6c0.4-1.2,1.5-2,2.7-2h60.7c1.8,0,3.2,1.7,2.8,3.5l-4.4,19.6c-0.3,1.3-1.5,2.3-2.8,2.3
                  h-17.3c-1.6,0-2.9,1.3-2.9,2.9v84c0,1.3-0.9,2.5-2.3,2.8l-21.1,4.7c-1.8,0.4-3.5-1-3.5-2.8V55.8c0-1.6-1.3-2.9-2.9-2.9h-12.9
                  C185.2,52.9,183.9,50.9,184.5,49.1z"/>
                <path class="st0" d="M154.2,29.5l-14.7,45.4l-14.7-45.4c-0.4-1.2-1.5-2-2.7-2h-21.7c-2,0-3.4,2-2.7,3.8l26.4,75.3
                  c0.1,0.3,0.2,0.6,0.2,0.9l0.3,51.8c0,1.3,0.9,2.5,2.2,2.8l12.2,3c0.5,0.1,0.9,0.1,1.4,0l12.2-3c1.3-0.3,2.2-1.5,2.2-2.8l0.3-51.8
                  c0-0.3,0.1-0.6,0.2-0.9l26.4-75.3c0.7-1.9-0.7-3.8-2.7-3.8h-21.7C155.6,27.5,154.5,28.3,154.2,29.5z"/>
              </g>
          </svg>
          <div class="c2a">
              <ng-container *ngIf="user">
                Hi {{userDisplayName}}!
                <br/>
              </ng-container>
              Ready to Cast
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
  <div class="player-container">
      <div class="player-box">
          <media-player #player 
              (playlistEnded)="endSession()"
              (newSession)="sessionChanged($event)"
              [inline]="true"
              [enableControls]="false"
              [autoplay]="true"></media-player>
      </div>
  </div>
</div>